import { useState, useEffect } from 'react';
import { Modal, Radio, Space } from 'antd';
import { Paragraph } from 'components/Base/Typography';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { TCreateNoteModalProps } from '../Notes.types';

const modules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const formats = ['bold', 'italic', 'underline', 'list', 'bullet', 'link'];

const CreateNoteModal = ({
  open,
  onClose,
  onSubmit,
  isLoading,
}: TCreateNoteModalProps) => {
  const [content, setContent] = useState('');
  const [isPrivate, setIsPrivate] = useState(true);

  useEffect(() => {
    if (open) {
      setContent('');
      setIsPrivate(true);
    }
  }, [open]);

  const handleOk = () => {
    if (!content || content === '<p><br></p>') {
      return;
    }
    onSubmit(content, isPrivate);
  };

  const isContentEmpty = !content || content === '<p><br></p>';

  return (
    <Modal
      title="Create New Note"
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText="Add Note"
      cancelText="Cancel"
      width={700}
      okButtonProps={{ disabled: isContentEmpty, loading: isLoading }}
      confirmLoading={isLoading}
    >
      <div style={{ marginBottom: 16 }}>
        <div className="rich-text-editor" style={{ marginBottom: 0 }}>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
            placeholder="Enter note content..."
          />
          <style>
            {`
              .rich-text-editor .ql-container {
                min-height: 120px;
                font-size: 14px;
              }
              .rich-text-editor .ql-editor {
                min-height: 120px;
              }
            `}
          </style>
        </div>
      </div>

      <div style={{ marginTop: 16 }}>
        <Paragraph style={{ marginBottom: 8, fontSize: 14 }}>
          Privacy:
        </Paragraph>
        <Radio.Group
          value={isPrivate}
          onChange={e => setIsPrivate(e.target.value)}
        >
          <Space direction="vertical">
            {/* eslint-disable-next-line react/jsx-boolean-value */}
            <Radio value={true}>
              Private (visible only to RFK Admin and ELC Lead)
            </Radio>
            <Radio value={false}>Public (visible to all team members)</Radio>
          </Space>
        </Radio.Group>
      </div>
    </Modal>
  );
};

export default CreateNoteModal;
